/* eslint-disable react/no-unknown-property */
/**
 * @author Vladislavs Zimnikovs <vladislavs.zimnikovs@scandiweb.com>
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package puma-mx
 */

import PropTypes from 'prop-types';
import { Children, cloneElement, PureComponent } from 'react';

import { ChildrenType } from 'Type/Common.type';

import './Tabs.style';

/** @namespace Scandipwa/Component/Tabs/Component */
export class TabsComponent extends PureComponent {
    static propTypes = {
        activeTab: PropTypes.string,
        onTabClick: PropTypes.func.isRequired,
        tabList: PropTypes.arrayOf(PropTypes.shape({
            id: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired
        })).isRequired,
        children: ChildrenType.isRequired,
        htmlName: PropTypes.string.isRequired,
        // eslint-disable-next-line react/boolean-prop-naming
        renderInactiveTabButtons: PropTypes.bool.isRequired
    };

    static defaultProps = {
        activeTab: null
    };

    onTabClick = (id) => () => {
        const { onTabClick } = this.props;

        onTabClick(id);
    };

    renderTabButtons = ({ id, label }) => {
        const { activeTab, tabList } = this.props;
        const [{ id: firstTab }] = tabList;

        return (
            <button
              key={ id }
              block="Tabs"
              elem="TabButton"
              mods={ { isActive: (activeTab || firstTab) === id, notActive: (activeTab || firstTab) !== id } }
              onClick={ this.onTabClick(id) }
            >
                { label }
            </button>
        );
    };

    renderTabs = (child) => {
        if (!child) {
            return null;
        }

        const { activeTab, tabList } = this.props;
        const { props: { id } } = child;
        const [{ id: firstTab }] = tabList;

        return cloneElement(child, { key: id, isActive: (activeTab || firstTab) === id });
    };

    render() {
        const {
            children, tabList, htmlName, renderInactiveTabButtons
        } = this.props;

        return (
            <div block="Tabs" name={ htmlName }>
                { tabList.length > 1 && (
                    <div block="Tabs" elem="TabList" name={ `${ htmlName }-list` }>
                        { tabList.map(this.renderTabButtons) }
                    </div>
                ) }
                { renderInactiveTabButtons
                && (
                    <div block="Tabs" elem="InactiveTabList" name={ `${ htmlName }-inactive-list` }>
                        { tabList.map(this.renderTabButtons) }
                    </div>
                ) }
                <div block="Tabs" elem="TabWrapper" name={ `${ htmlName }-wrapper` }>
                    { Children.map(children, this.renderTabs) }
                </div>
            </div>
        );
    }
}

export default TabsComponent;
